import './error404.scss';

/* Init function to handle go-back link in 404 page */

export default function Error404() {
    const $page404 = document.querySelector('.error-404') as HTMLDivElement;

    if ($page404) {
        const $goBackLink = $page404.querySelector('a');

        $goBackLink?.addEventListener('click', () => {
            history.back();
        });

        $goBackLink?.addEventListener('keypress', e => {
            if (e.key === 'Enter') {
                history.back();
            }
        });
    }
}
